import { CSSProperties } from "react";
import { CircularProgress, CircularProgressProps } from "@mui/material";

interface Props {
	style?: CSSProperties;
	spinnerProps?: CircularProgressProps;
}

const Preloader = ({ style, spinnerProps }: Props) => {
	return (
		<div
			style={{
				position: "absolute",
				left: "50%",
				top: "50%",
				transform: "translate(-50%, -50%)",
				...style,
			}}
		>
			<CircularProgress {...spinnerProps} />
		</div>
	);
};

export default Preloader;
